import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Facilities from './pages/Facilities';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import Location from './pages/Location';
import Contact from './pages/Contact';
import AdminPanel from './pages/AdminPanel';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/Location" element={<Location />} />
        <Route path="/Contact" element={<Contact />} />
        {/* <Route path="/admin-ballaeja-secret" element={<AdminPanel />} /> */}
        <Route path="/login-admin" element={<Login />} />
        <Route 
          path="/admin-ballaeja-secret" 
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
}

export default App;